export default {"src":"/_next/static/media/quora.cc0427c0.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};